import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import "./App.css"
import openIC from "./image/open.svg"
import downloadIC from "./image/download.svg"
import QRIC from "./image/qr.svg"
import logo from "./image/logo.svg"

const STORE_URLS = {
  android: 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app',
  ios: 'https://apps.apple.com/au/app/rewardstick/id6751297042',
};

const APP_SCHEME = 'rewardstick://';
const ANDROID_PACKAGE = 'com.ecologital.rewardstick_consumer_app';

function detectPlatform() {
  const ua = navigator.userAgent || navigator.vendor || '';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
}

const App = () => {
  const location = useLocation();
  const platform = detectPlatform();

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const cardIndex = pathSegments.findIndex(segment => segment === 'cardscan');
    const cardId = cardIndex !== -1 ? pathSegments[cardIndex + 1] : null;
    if (!cardId) return;

    const fallback = {
      android: STORE_URLS.android,
      ios: STORE_URLS.ios,
      web: `https://deeplink.throbox.com/rewardstick/cardscan/${cardId}`,
    };

    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    if (isAndroid) {
      const intentUrl = `intent://cardscan/${cardId}#Intent;scheme=rewardstick;package=${ANDROID_PACKAGE};end`;
      window.location.href = intentUrl;
      setTimeout(() => { window.location.href = fallback.android; }, 1500);
    } else if (isIOS) {
      window.location.href = `rewardstick://cardscan/${cardId}`;
      setTimeout(() => { window.location.href = fallback.ios; }, 1500);
    } else {
      window.location.href = fallback.web;
    }
  }, [location]);

  const handleOpenApp = () => {
    if (platform === 'android') {
      const intentUrl =
        `intent://#Intent;` +
        `scheme=rewardstick;` +
        `package=${ANDROID_PACKAGE};` +
        `S.browser_fallback_url=${encodeURIComponent(STORE_URLS.android)};` +
        `end`;
      window.location.href = intentUrl;
    } else if (platform === 'ios') {
      window.location.href = APP_SCHEME;
      const timer = setTimeout(() => {
        window.location.href = STORE_URLS.ios;
      }, 2000);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearTimeout(timer);
      }, { once: true });
    } else {
      window.open(STORE_URLS.android, '_blank');
    }
  };

  const handleDownloadApp = () => {
    if (platform === 'android') {
      window.open(STORE_URLS.android, '_blank');
    } else if (platform === 'ios') {
      window.open(STORE_URLS.ios, '_blank');
    } else {
      window.open(STORE_URLS.ios, '_blank');
      window.open(STORE_URLS.android, '_blank');
    }
  };

  return (
    <div className='App'>
      <img alt='' src={logo} className='logo-style' />
      <div className='App-container'>
        <div className='App-inner-container'>
          <div className='qr-wrapper'>
            <img alt='' src={QRIC} className='qr-img' />
          </div>
          <div className='inner-container-header'>
            Join using <div className='header-bold'>Rewardstick</div>
          </div>
          <div className='redirect-text'>
            Redirecting to your app <div className='timer-text'>1 sec</div>
          </div>
          <div className='open-btn' onClick={handleOpenApp}>
            <img alt='' src={openIC} className='open-ic' />Open App
          </div>
          <div className='download-btn' onClick={handleDownloadApp}>
            <img alt='' src={downloadIC} className='download-ic' />Download App
          </div>
          <div className='privacy-content'>
            <div>© 2025 Loyalty Scanner Inc. All rights reserved.</div>
            <div className='policy'>
              <span>Privacy Policy</span>
              <span>Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
